export function normalizeIsoDate(raw) {
    const value = String(raw || '').trim()
    if (!value) return ''

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (!match) return ''

    return `${match[1]}-${match[2]}-${match[3]}`
}

export function getTodayIsoDate() {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export function parseCalendarDate(raw) {
    const normalized = normalizeIsoDate(raw)
    if (!normalized) return null

    const [year, month, day] = normalized.split('-').map(Number)
    if (!year || !month || !day) return null

    const date = new Date(year, month - 1, day)
    date.setHours(0, 0, 0, 0)

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null
    }

    return date
}

export function compareCalendarDates(left, right) {
    const leftDate = parseCalendarDate(left)
    const rightDate = parseCalendarDate(right)

    if (!leftDate && !rightDate) return 0
    if (!leftDate) return 1
    if (!rightDate) return -1

    return leftDate.getTime() - rightDate.getTime()
}

export function formatCalendarDate(raw, locale = 'nl-NL', options = { day: 'numeric', month: 'long', year: 'numeric' }) {
    const date = parseCalendarDate(raw)
    if (!date) return ''

    return date.toLocaleDateString(locale, options)
}

export function getCalendarYear(raw) {
    const date = parseCalendarDate(raw)
    return date ? date.getFullYear() : null
}

export function getAgeFromCalendarDate(raw, referenceRaw = null) {
    const birth = parseCalendarDate(raw)
    if (!birth) return null

    const reference = referenceRaw ? parseCalendarDate(referenceRaw) : new Date()
    if (!reference) return null

    let age = reference.getFullYear() - birth.getFullYear()
    const monthDiff = reference.getMonth() - birth.getMonth()

    if (monthDiff < 0 || (monthDiff === 0 && reference.getDate() < birth.getDate())) {
        age--
    }

    return age
}

export function isTodayCalendarDate(raw) {
    const date = parseCalendarDate(raw)
    if (!date) return false

    const today = new Date()

    return date.getDate() === today.getDate()
        && date.getMonth() === today.getMonth()
        && date.getFullYear() === today.getFullYear()
}

export function getDaysUntilBirthday(raw) {
    const birth = parseCalendarDate(raw)
    if (!birth) return null

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const next = new Date(today.getFullYear(), birth.getMonth(), birth.getDate())
    next.setHours(0, 0, 0, 0)

    if (next < today) {
        next.setFullYear(today.getFullYear() + 1)
    }

    return Math.round((next.getTime() - today.getTime()) / 86400000)
}
